import { connect } from 'react-redux';
import { createSelector, createStructuredSelector } from 'reselect';
import { bindActionCreators } from 'redux';
import { property, isNil, constant, flow } from 'lodash';

import config from '../../../config';

import ContactInfo from '../components/ContactInfo';
import {
  startRequest,
  startRequestSkipLoading,
  setContactInfo,
} from '../redux/contactInfo/actions';
import { startRequest as startReadOnlyRequest } from '../redux/readOnly/actions';
import { resetTourStatus } from '../../App/redux/bannerList/actions';

export const getAppUserSelector = createSelector(property('app.user'), (data) => data.toJS());
const getProfileReadOnlySelector = createSelector(property('profile.readOnly'), (data) =>
  data.toJS(),
);
const getProfileContactInfoSelector = createSelector(property('profile.contactInfo'), (data) =>
  data.toJS(),
);

const loadingSelector = createSelector(
  [getAppUserSelector, getProfileReadOnlySelector, getProfileContactInfoSelector],
  (userSlice, readOnlySlice, contactInfoSlice) => {
    return (
      userSlice.loading ||
      isNil(userSlice.data) ||
      readOnlySlice.loading ||
      isNil(readOnlySlice.data) ||
      contactInfoSlice.loading ||
      isNil(contactInfoSlice.data)
    );
  },
);

const hasErrorSelector = createSelector(
  [getAppUserSelector, getProfileReadOnlySelector, getProfileContactInfoSelector],
  (user, readOnly, contactInfo) => {
    return !isNil(user.error) || !isNil(readOnly.error) || !isNil(contactInfo.error);
  },
);

const mapStateToProps = createStructuredSelector({
  appConfig: constant(config),
  user: flow(getAppUserSelector, property('data')),
  contactInfo: flow(getProfileContactInfoSelector, property('data')),
  readOnly: flow(getProfileReadOnlySelector, property('data')),
  loading: loadingSelector,
  hasError: hasErrorSelector,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      loadData: startRequest,
      loadReadOnly: startReadOnlyRequest,
      setContactInfo: setContactInfo,
      updateData: startRequestSkipLoading,
      resetTour: resetTourStatus,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(ContactInfo);
